<template>
  <div class="animation-stage">
    <section class="panel-wrap">
      <div class="weui-panel weui-panel_access">
        <div class="weui-panel__hd">图文组合列表</div>
        <div class="weui-panel__bd">
          <!-- start -->
          <transition-group
            tag="section"
            name="weui-card-item"
            appear
          >
            <a
              href="javascript:void(0);"
              class="weui-media-box weui-media-box_appmsg animated"
              v-for="(el) in listData"
              :key="`item-${el.id}`"
              @click="_onDbItem(el.id)"
            >
              <div class="weui-media-box__hd">
                <img
                  class="weui-media-box__thumb"
                  src="https://avatars.dicebear.com/v2/identicon/.svg?options[colors][]=indigo&options[colors][]=cyan&options[colorLevel]=500"
                  alt="">
              </div>
              <div class="weui-media-box__bd">
                <h4 class="weui-media-box__title">{{ el.title }} {{ el.id }}</h4>
                <p class="weui-media-box__desc">
                  {{ el.desc }}
                </p>
              </div>
            </a>
          </transition-group>
          <!-- end -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'AniStage',

    data () {
      return {
        listData: Array.from(Array(5)).map((_, idx) => {
          return {
            id: `item-${idx}`,
            title: '标题',
            desc: '由各种物质组成的巨型球状天体，叫做星球。星球有一定的形状，有自己的运行轨道。'
          }
        })
      }
    },

    methods: {
      _onDbItem (identity) {
        this.listData.some((el, idx) => {
          if (el.id === identity) {
            this.listData.splice(idx, 1)
            return true
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  @import "stage.scss";
</style>
